import React from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { relationShipOptionList } from "../../../utils/commonSelectBoxOptions/commonSelectBoxOptions";
import { toast } from "react-toastify";
import { useUpdatePersonalDetails } from "../../../queries/employeeQueries";
import { fullNameRegex, phoneRegex } from "../../../utils/regex/regex";
const EditOrAddEmergencyContactModal = ({
  openModal,
  onCloseModal,
  employee,
}) => {

  const employeeId = employee?.employee_id;
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      emergency_contact_name: employee?.emergency_contact_name || "",
      emergency_phone_1: employee?.emergency_phone_1 || "",
      emergency_phone_2: employee?.emergency_phone_2 || "",
      emergency_contact_relation: employee?.emergency_contact_relation || "",
    },
  });
  const { mutate: updatePersonalDetails } = useUpdatePersonalDetails();

  const onSubmit = (data) => {
    const reqObj = {};
    const dataKeys = Object.keys(data);
    dataKeys.forEach((item) => {
      const getValue = data[item];
      if (getValue || typeof getValue === "boolean") {
        reqObj[item] = getValue;
      }
    });


    updatePersonalDetails(
      { ...data, employeeId },
      {
        onSuccess: (res) => {
          if (res?.status) {
            toast.success(res.message);
            onCloseModal();
          } else {
            toast.info("Failed to update personal details");
          }
        },
        onError: () => {
          toast.info("Failed to update personal details");
        },
      }
    );
    
  };

  return (
    <>
      <Modal open={openModal} onClose={onCloseModal} center>
        <div className="p-5 max-w-[520px]">
          <>
            <h2 className="text-lg leading-6 text-[#1F2937] font-semibold mb-5">
              Edit/Add Emergency Contact
            </h2>
            <form
              className="flex flex-col gap-4"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="flex flex-col">
                <label className="text-sm font-medium text-black">
                  Name <span className="text-red-700">*</span>
                </label>
                <input
                  {...register("emergency_contact_name", {
                    required: "This field is required",
                    pattern: {
                      value: fullNameRegex,
                      message: "Name cannot start with a space, and special characters or numbers are not allowed!",
                    },
                  })}
                  type="text"
                  className="h-[38px]"
                />
              </div>

              {errors?.emergency_contact_name && (
                <span className="text-red-600">
                  {errors?.emergency_contact_name?.message}
                </span>
              )}

              <div className="flex flex-col">
                <label className="text-sm font-medium text-black">
                  Relationship
                </label>
                <Controller
                  control={control}
                  name="emergency_contact_relation"
                  render={({ field: { onChange, value } }) => {
                    return (
                      <Select
                        options={relationShipOptionList}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        placeholder={
                          relationShipOptionList?.find((i) => i.value === value)
                            ?.label || "Select"
                        }
                        onChange={(e) => {
                          onChange(e.value);
                        }}
                      />
                    );
                  }}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-sm font-medium text-black">
                  Emergency Phone Number 1
                </label>
                <div className="flex h-[38px]">
                  {/* <Select
                    options={[
                      {
                        label: (
                          <div className="flex">
                            <img src="/images/IN-country.svg" />
                            <span>+91</span>
                          </div>
                        ),
                      },
                    ]}
                    components={{ DropdownIndicator }}
                    placeholder={"+91"}
                    className="w-[150px] country-input-select"
                  /> */}
                  {/* <input
                    type="text"
                    placeholder="Enter your phone number"
                    className="rounded-l-none country-input"
                  /> */}

                  <input
                    type="text"
                    id="phone"
                    inputMode="numeric"
                    {...register("emergency_phone_1", {
                      pattern: {
                        value: phoneRegex,
                        message: "Please enter a valid phone number",
                      },
                    })}
                  />
                </div>
                {errors?.emergency_phone_1 && (
                  <span className="text-red-600">
                    {errors?.emergency_phone_1?.message}
                  </span>
                )}
              </div>
              <div className="flex flex-col">
                <label className="text-sm font-medium text-black">
                  Emergency Phone Number 2
                </label>
                <div className="flex h-[38px]">
                  <input
                    type="text"
                    id="phone"
                    inputMode="numeric"
                    {...register("emergency_phone_2", {
                      pattern: {
                        value: phoneRegex,
                        message: "Please enter a valid phone number",
                      },
                    })}
                  />
                </div>
                {errors?.emergency_phone_1 && (
                  <span className="text-red-600">
                    {errors?.emergency_phone_2?.message}
                  </span>
                )}
              </div>

              <div className="flex justify-end gap-3">
                <button
                  type="button"
                  className="btn btn--border text-sm font-medium"
                  onClick={onCloseModal}
                >
                  Cancel
                </button>
                <button type="submit" className="btn text-sm font-medium">
                  Save Changes
                </button>
              </div>
            </form>
          </>
        </div>
      </Modal>
    </>
  );
};

export default EditOrAddEmergencyContactModal;
